import React, {useContext, useState} from 'react';
import OrgPage from "../../../components/OrgPage";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {SystemManager_API} from "../SystemManager.API";
import moment from "moment";
import icons from "../../../assets/icons";
import {AuthContext} from "../../../context/AuthContext";
import {formatDate} from "../../../utils/utils";

function TestResults(props) {
    const {
        getTestResults
    } = SystemManager_API.doctors

    const [refresh, setRefresh] = useState(false)
    const userId = useContext(AuthContext)?.token?.userId
    const MistakeIcon = () => <img src={icons.mistakeSVG} alt="mistake"/>
    const PointIcon = () => <img src={icons.pointSVG} alt="point"/>

    return (
        <OrgPage
            url={`${process.env.REACT_APP_BASE_URL}` + getTestResults(userId).api}
            refresh={refresh}
            exportTemplateButtons={{export: false, registry: false}}
            filterBarButtons={{downloadTemplate: {show: false,}}}
            filterFieldsConf={{
                fio: true,
                city: true,
                date: true,
                period: true,
                testStatus: true,
                testType: true,
                verificationCenterName: true
            }}
            breadCrumbsItems={[
                {title: 'Доктор'},
                {title: 'Результаты тестирования', actual: true},
            ]}

            firstRow={[
                {title: 'ФИО', id: 'fio'},
                {title: 'Дата прохождения', id: "date", style: {width: '250px'}},
                {title: 'Удост. Центр', id: 'ver_name', style: {width: '250px'}},
                {title: 'Город'},
                {title: 'Вид тестирования'},
                {title: <PointIcon/>, columnId: 'score',},
                {title: <MistakeIcon/>, columnId: 'mistakes'},
                {title: 'Рейтинг', id: 'rating'},
                {title: 'Статус'},
            ]}

            haveToShow={[
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.fio}/>}},
                {
                    type: 'wrapperCell',
                    typeData: {
                        cell: props => <LinkCell3 linkTitle={formatDate(props?.all?.result_date)}/>
                    }
                },
                {
                    type: 'wrapperCell',
                    typeData: {cell: props => <LinkCell3 linkTitle={props.all?.name}/>}
                },
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.city}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all?.test_results?.type}/>}},
                {
                    type: 'wrapperCell',
                    typeData: {cell: props => <LinkCell3 linkTitle={props.all?.test_results?.score}/>}
                },
                {
                    type: 'wrapperCell',
                    typeData: {cell: props => <LinkCell3 linkTitle={props.all?.test_results?.mistakes}/>}
                },
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all?.rating}/>}},
                {
                    type: 'wrapperCell',
                    typeData: {cell: props => <LinkCell3 linkTitle={props.all?.test_results?.status}/>}
                },

            ]}
        />
    );
}

export default TestResults;